import React from 'react'
import styled from '@emotion/styled'
import { ChevronLeft } from '@mui/icons-material'
import { Button, ButtonProps } from '@mui/material'

const StyledBackBtn = styled(Button)({
  borderRadius: '8px',
  padding: '8px '
})

function BackButtonSquare(props: ButtonProps) {
  return (
    <StyledBackBtn {...props} variant='filled'>
      <ChevronLeft sx={{ fontSize: '28px' }} />
    </StyledBackBtn>
  )
}

export default BackButtonSquare
